import { render, staticRenderFns } from "./BizCouponWriteOff.vue?vue&type=template&id=74dabb87&scoped=true&"
import script from "./BizCouponWriteOff.vue?vue&type=script&lang=js&"
export * from "./BizCouponWriteOff.vue?vue&type=script&lang=js&"
import style0 from "./BizCouponWriteOff.vue?vue&type=style&index=0&id=74dabb87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dabb87",
  null
  
)

export default component.exports